<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">No Faktur Pajak</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="8" sm="8" md="6" lg="6">
            <v-text-field
              outlined
              flat
              label="Tax Serial Number"
              background-color="white"
              v-model="form.taxInvoiceSerialNumber"
              :rules="[v => !!v || 'Tax Serial Number is required']"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">
          Save
        </v-btn>
        <v-btn color="error" @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-sale-tax",
  props: {
    dialog: Boolean,
    form: Object,
  },
  methods: {
    save() {
      this.$emit("save", this.form);
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
